module.exports = __webpack_public_path__ + "static/media/bar_oscillator.a4075354.svg";